import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface SupportAccordionProps {
    element: any
}

const SupportAccordion: React.FC<SupportAccordionProps> = (element) => {
    const [active, setActive] = useState<any[]>([]);

    const handleAccordionItems = (AccordionItem : any) => {
        if(AccordionItem){
            return Array.isArray(AccordionItem) && AccordionItem.map((item, index) => {
                const accordionId = element?.element?.AccordionMainTitle + index;
                return(
                    <div className={active.includes(accordionId) ? "accdn-item active" : "accdn-item"} key={index} onClick={(event: any)=>handleAccordionClick(event, accordionId)}>
                        <div>
                            <h4 className="accdn-head">{item?.AccordionTitle}</h4>
                        </div>
                        <div className="accdn-content barlow-font" style={active.includes(accordionId) ? {display: "block"} : {display: "none"}}>
                            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.AccordionContent}</ReactMarkdown>
                        </div>
                    </div>
                )
            });
        }
    }
    const handleAccordionClick = (event: any, accordionId: string) => {
        const offsetTop = event.target.getBoundingClientRect().top;
        const navbar = document.getElementsByClassName("navbar")[0]?.clientHeight || 0;
        setActive((prevActive) => {
            if (prevActive.includes(accordionId)) {
                return prevActive.filter((id) => id !== accordionId);
            } else {
                scrollTo(offsetTop-navbar, 800);
                return [...prevActive, accordionId];
            }
        });
    }

    const scrollTo = (to: number, duration: number) => {
        const start = window.scrollY;
        const change = to + start;
        let startTime = 0;
        const animateScroll = (currentTime: number) => {
            if (startTime === 0) startTime = currentTime; 
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const easeInOutQuad = (progress: number) => progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
            window.scrollTo(0, change * easeInOutQuad(progress));
            if (timeElapsed < duration) {
                requestAnimationFrame(animateScroll);
            }
        }; 
        requestAnimationFrame(animateScroll);
    };

    return (
      <>
        <div className="container-fluid spacer-top">
            <h3 className="accdn-main-title pb-3">{element?.element?.AccordionMainTitle}</h3>
            <div className="custom-accdn2 expandable">
                {handleAccordionItems(element?.element?.AccordionItem)}
            </div>
        </div>
      </>
    );
};

export default SupportAccordion;